export const trackEvent = (eventName: string, params = {}) => {
  const gtag = (window as any).gtag;
  if (!gtag) return;

  gtag("event", eventName, {
    ...params,
  });
};
